import React from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import './ClientUpdate.scss';

export const ClientUpdate = () => {
  const isLoading = useSelector((state) => state.app.isLoading);

  useEffect(() => {
    localStorage.setItem('upgraded', 'true');
  }, []);

  return (
    <div className={'clientUpdate-container'}>
      { isLoading ? <div/> : <>
        <div className='clientUpdate-content'>
          <p className='clientUpdate-heading'>A Docrio Email update is available!</p>
          <p className='clientUpdate-paragraph'>Docrio Email will automatically restart in 5 seconds.</p>
        </div>
      </>
      }
    </div>
  );
};
